export default __webpack_public_path__ + "static/media/tag_bold.f927dd5a.svg";